export type IconName =
  | "alert"
  | "book"
  | "camera"
  | "check"
  | "family"
  | "home"
  | "map"
  | "phone"
  | "search"
  | "settings"
  | "shield"
  | "water";

interface IconProps {
  readonly name: IconName;
}

const paths: Readonly<Record<IconName, string>> = {
  alert: "M12 3 2.8 19h18.4L12 3Zm0 5v5m0 3.5v.1",
  book: "M12 6.5C9.7 4.9 6.8 4.2 3 4.5v14c3.8-.3 6.7.4 9 2 2.3-1.6 5.2-2.3 9-2v-14c-3.8-.3-6.7.4-9 2Zm0 0v14",
  camera: "M4 7.5h3l1.4-2h7.2l1.4 2h3v11H4v-11Zm8 7a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4Z",
  check: "M4 12.5 9.2 18 20 6",
  family:
    "M8.2 11.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4Zm7.7-1.2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM2.8 19.2v-1.6c0-2.4 2.4-4.2 5.4-4.2s5.4 1.8 5.4 4.2v1.6m.2-6.2c3.5 0 6 1.7 6 4.2v2",
  home: "m3 10 9-7 9 7v10h-6v-6H9v6H3V10Z",
  map: "M9 4 3.5 6v14L9 18l6 2 5.5-2V4L15 6 9 4Zm0 0v14m6-12v14",
  phone:
    "M7.2 3.5 5 4.7c-.8.5-1.2 1.5-.9 2.4 1.7 5.7 6.2 10.2 11.9 11.9.9.3 1.9-.1 2.4-.9l1.2-2.2-4-2.1-1.2 1.4c-2.3-1-4.4-3.1-5.4-5.4l1.4-1.2-2.2-4.1Z",
  search: "m20 20-4.5-4.5m2-5.5a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z",
  settings:
    "M12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm0-5.5 1 2.2 2.4.6 2-1.2 2 2-1.2 2 .6 2.4L21 12l-2.2 1 .4 2.4 1.2 2-2 2-2-1.2-2.4.6L12 21l-1-2.2-2.4-.6-2 1.2-2-2 1.2-2L5.2 13 3 12l2.2-1-.4-2.4-1.2-2 2-2 2 1.2 2.4-.6L12 3Z",
  shield: "M12 3 5 6v5c0 4.8 2.9 8.1 7 10 4.1-1.9 7-5.2 7-10V6l-7-3Z",
  water:
    "M4 15.5c1.5 1.5 3.2 1.5 4.7 0 1.5-1.5 3.2-1.5 4.7 0 1.5 1.5 3.2 1.5 4.7 0M4 10c1.5 1.5 3.2 1.5 4.7 0 1.5-1.5 3.2-1.5 4.7 0 1.5 1.5 3.2 1.5 4.7 0",
};

export function Icon({ name }: IconProps) {
  return (
    <svg aria-hidden="true" className="icon" fill="none" viewBox="0 0 24 24">
      <path
        d={paths[name]}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
    </svg>
  );
}
